// extracted by mini-css-extract-plugin
var _1 = "LayoutHeaderAddEntityButton-moduleLayoutHeaderAddEntityButton__n_G0g Select-moduleSelect__MROu3";
var _2 = "LayoutHeaderAddEntityButton-moduleicon__CwfUs SelectEntityItemAvatar-moduleavatar__zeGPU";
export { _1 as "LayoutHeaderAddEntityButton", _2 as "icon" }
